import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('SHIPPINGS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class ShippingsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'shippings' como el nombre del recurso a la clase base
    super('shippings');
    log.debug('Servicio de Movimientos inicializado');
  }

  /**
   * Recepción de delivery: el API crea en una llamada el documento ENTRADA,
   * las N piezas SIN etiqueta (una por unidad recibida) y su bitácora.
   */
  public async receive(payload: {
    warehouse: string;
    type?: 'ENTRADA' | 'TRASPASO';
    deliveryFolio?: string;
    arrivedAsStated?: boolean;
    exclusiveDelivery?: boolean;
    carrierName?: string;
    origin?: string;
    comments?: string;
    /** Solicitud de material que surte la entrada (queda Recibida). */
    materialRequest?: string;
    /** Insumos que no llegaron. */
    backorder?: { product: string; quantity: number }[];
    /** Insumos que llegaron de más (no venían en el DLV). */
    extra?: { product: string; quantity: number }[];
    rows: { product: string; batch?: string; expiration?: string; quantity: number }[];
  }): Promise<Utils.ApiResponse<any>> {
    return this.request<any>('shippings/reception', 'POST', payload);
  }

  /**
   * Asocia etiquetas RFID a líneas (una por unidad) de una recepción: crea
   * las piezas en el locker de la recepción. Las líneas ya etiquetadas
   * (guardadas en `rfid` del documento) se ignoran, así no se duplican.
   */
  public async tagReception(payload: {
    shipping: string;
    lines: { line: string; product: string; batch?: string | null; expiration?: string | null; tagRfid: string }[];
  }): Promise<Utils.ApiResponse<any>> {
    return this.request<any>('shippings/receptionTag', 'POST', payload);
  }

}
